@if (hasBackdrop()) {
  <div class="overlay-backdrop" role="presentation" (click)="back.emit()"></div>
}
<div
  class="sheet-dialog"
  tabindex="0"
  [cdkTrapFocus]="true"
  [cdkTrapFocusAutoCapture]="true"
>
  <header class="sheet-dialog__header">
    <hgroup>
      <h1 class="title">{{ title() | translate }}</h1>
      @if (subtitle()) {
        <h2 class="subtitle">
          {{ subtitle() || '' | translate }}
        </h2>
      }
    </hgroup>
  </header>
  <div class="sheet-dialog__body">
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>

  <ng-content select="[footer]"></ng-content>
</div>
